export default __webpack_public_path__ + "static/media/wcomment.f51f335b.png";